"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dismissNotification = exports.dismissAllNotifications = exports.configure = exports.notifyStart = exports.notifyWarning = exports.notifySuccess = exports.notify = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_toastify_1 = require("react-toastify");
const flash_notifications_constants_1 = require("./flash-notifications.constants");
const FlashNotification_1 = require("./components/FlashNotification/FlashNotification");
const FlashNotificationCloseButton_1 = require("./components/FlashNotificationCloseButton/FlashNotificationCloseButton");
const FlashNotificationMessageWithButton_1 = require("./components/FlashNotificationMessageWithButton/FlashNotificationMessageWithButton");
function notify(messageOrOptions, level, position, duration, toastOptions) {
    if (isFlashNotificationOptions(messageOrOptions)) {
        const { message, level = flash_notifications_constants_1.FlashNotificationLevel.success, autoClose = flash_notifications_constants_1.FLASH_NOTIFICATION_DURATION, position = flash_notifications_constants_1.FlashNotificationPosition.bottomLeft, pauseOnHover = true, button, ...toastOptions } = messageOrOptions;
        (0, react_toastify_1.toast)((0, jsx_runtime_1.jsx)(FlashNotification_1.FlashNotification, { level: level, children: button ? ((0, jsx_runtime_1.jsx)(FlashNotificationMessageWithButton_1.FlashNotificationMessageWithButton
            // @ts-expect-error Somthing went wrong with typing. Need to fix
            , { 
                // @ts-expect-error Somthing went wrong with typing. Need to fix
                message: message, buttonLabel: button.label, onClick: button.onClick })) : (message) }), {
            position,
            autoClose,
            pauseOnHover,
            ...toastOptions,
        });
    }
    else {
        // @ts-expect-error Somthing went wrong with typing. Need to fix
        (0, react_toastify_1.toast)((0, jsx_runtime_1.jsx)(FlashNotification_1.FlashNotification, { level: level, children: messageOrOptions }), {
            position,
            autoClose: duration,
            ...(toastOptions || { pauseOnHover: true }),
        });
    }
}
exports.notify = notify;
function notifySuccess(message, position = flash_notifications_constants_1.FlashNotificationPosition.bottomLeft, duration = flash_notifications_constants_1.FLASH_NOTIFICATION_DURATION, toastOptions) {
    notify(message, flash_notifications_constants_1.FlashNotificationLevel.success, position, duration, toastOptions);
}
exports.notifySuccess = notifySuccess;
function notifyWarning(message, position = flash_notifications_constants_1.FlashNotificationPosition.bottomLeft, duration = flash_notifications_constants_1.FLASH_NOTIFICATION_DURATION, toastOptions) {
    notify(message, flash_notifications_constants_1.FlashNotificationLevel.warning, position, duration, toastOptions);
}
exports.notifyWarning = notifyWarning;
function notifyStart(message, position = flash_notifications_constants_1.FlashNotificationPosition.bottomLeft, duration = flash_notifications_constants_1.FLASH_NOTIFICATION_DURATION, toastOptions) {
    notify(message, flash_notifications_constants_1.FlashNotificationLevel.start, position, duration, toastOptions);
}
exports.notifyStart = notifyStart;
function configure() {
    react_toastify_1.toast.configure({
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnFocusLoss: false,
        draggable: false,
        pauseOnHover: false,
        transition: react_toastify_1.Zoom,
        className: "flash-notification-toast-container",
        toastClassName: "flash-notification-toast",
        closeButton: FlashNotificationCloseButton_1.FlashNotificationCloseButton,
    });
}
exports.configure = configure;
function dismissAllNotifications() {
    react_toastify_1.toast.dismiss();
}
exports.dismissAllNotifications = dismissAllNotifications;
function dismissNotification(id) {
    react_toastify_1.toast.dismiss(id);
}
exports.dismissNotification = dismissNotification;
const isFlashNotificationOptions = (params) => {
    return typeof params === "object";
};
